import * as e from "react";
import t, { useState as n, useEffect as r, useCallback as o } from "react";
import i from "prop-types";
import { transparentize as a } from "polished";
import l from "lodash/debounce";
import c, { Justify as s, Align as p } from "@leafygreen-ui/popover";
export { Justify } from "@leafygreen-ui/popover";
import { useIdAllocator as f, useEscapeKey as u, useEventListener as h } from "@leafygreen-ui/hooks";
import { css as g, cx as d } from "@leafygreen-ui/emotion";
import { palette as m } from "@leafygreen-ui/palette";
import { fontFamilies as b } from "@leafygreen-ui/tokens";
import { Theme as y, isComponentType as v } from "@leafygreen-ui/lib";
import { useUpdatedBaseFontSize as x, bodyTypeScaleStyles as w } from "@leafygreen-ui/typography";
import { isComponentGlyph as O } from "@leafygreen-ui/icon";
import j from "lodash/clamp";
import { useDarkMode as k } from "@leafygreen-ui/leafygreen-provider";

function E(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function C(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? E(Object(n), !0).forEach(function (t) {
      P(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : E(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

function P(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}

function N() {
  return N = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  }, N.apply(this, arguments);
}

function M(e, t) {
  if (null == e) return {};

  var n,
      r,
      o = function (e, t) {
    if (null == e) return {};
    var n,
        r,
        o = {},
        i = Object.keys(e);

    for (r = 0; r < i.length; r++) {
      n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
    }

    return o;
  }(e, t);

  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);

    for (r = 0; r < i.length; r++) {
      n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
    }
  }

  return o;
}

function I(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}

function S(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null == n) return;
    var r,
        o,
        i = [],
        a = !0,
        l = !1;

    try {
      for (n = n.call(e); !(a = (r = n.next()).done) && (i.push(r.value), !t || i.length !== t); a = !0) {
        ;
      }
    } catch (e) {
      l = !0, o = e;
    } finally {
      try {
        a || null == n.return || n.return();
      } finally {
        if (l) throw o;
      }
    }

    return i;
  }(e, t) || function (e, t) {
    if (!e) return;
    if ("string" == typeof e) return F(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    "Object" === n && e.constructor && (n = e.constructor.name);
    if ("Map" === n || "Set" === n) return Array.from(e);
    if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return F(e, t);
  }(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function F(e, t) {
  (null == t || t > e.length) && (t = e.length);

  for (var n = 0, r = new Array(t); n < t; n++) {
    r[n] = e[n];
  }

  return r;
}

var T, A, L;

function z(t) {
  return e.createElement("svg", N({
    width: 26,
    height: 8,
    fill: "#001E2B",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 8"
  }, t), e.createElement("path", {
    d: "M27 0H-1v1h.699a10 10 0 017.26 3.123l1.685 1.78a6 6 0 008.712 0l1.686-1.78A10 10 0 0126.302 1H27V0z"
  }));
}

var B,
    H,
    R,
    D,
    U,
    X,
    Y,
    Z,
    G,
    q,
    J = ["open", "setOpen", "className", "children", "trigger", "triggerEvent", "darkMode", "enabled", "align", "justify", "spacing", "id", "shouldClose", "usePortal", "portalClassName", "portalContainer", "scrollContainer", "popoverZIndex", "refEl", "onClose"],
    K = {
  Hover: "hover",
  Click: "click"
},
    V = {
  Top: p.Top,
  Bottom: p.Bottom,
  Left: p.Left,
  Right: p.Right
},
    $ = g(B || (B = I(["\n  margin: unset;\n  font-family: ", ";\n  color: ", ";\n  font-weight: 400;\n  width: 100%;\n  overflow-wrap: anywhere;\n"])), b.default, m.gray.light1),
    Q = g(H || (H = I(["\n  display: flex;\n  align-items: center;\n  border-radius: ", "px;\n  padding: 12px ", "px;\n  box-shadow: 0px 2px 4px -1px ", ";\n  cursor: default;\n  width: fit-content;\n  max-width: 256px;\n"])), 16, 16, a(.85, m.black)),
    W = g(R || (R = I(["\n  position: relative;\n"]))),
    _ = (P(Z = {}, y.Light, {
  tooltip: g(D || (D = I(["\n      background-color: ", ";\n      color: ", ";\n    "])), m.black, m.gray.light1),
  children: g(U || (U = I(["\n      color: inherit;\n    "]))),
  notchFill: m.black
}), P(Z, y.Dark, {
  tooltip: g(X || (X = I(["\n      background-color: ", ";\n      color: ", ";\n    "])), m.gray.light2, m.black),
  children: g(Y || (Y = I(["\n      color: inherit;\n    "]))),
  notchFill: m.gray.light2
}), Z),
    ee = g(G || (G = I(["\n  min-height: ", "px;\n"])), 58),
    te = function te(e) {
  e.stopPropagation();
};

function ne(e) {
  var i = e.open,
      a = e.setOpen,
      p = e.className,
      m = e.children,
      b = e.trigger,
      y = e.triggerEvent,
      E = void 0 === y ? K.Hover : y,
      F = e.darkMode,
      B = e.enabled,
      H = void 0 === B || B,
      R = e.align,
      D = void 0 === R ? "top" : R,
      U = e.justify,
      X = void 0 === U ? "start" : U,
      Y = e.spacing,
      Z = void 0 === Y ? 12 : Y,
      G = e.id,
      ne = e.shouldClose,
      re = e.usePortal,
      oe = void 0 === re || re,
      ie = e.portalClassName,
      ae = e.portalContainer,
      le = e.scrollContainer,
      ce = e.popoverZIndex,
      se = e.refEl,
      pe = e.onClose,
      fe = void 0 === pe ? function () {} : pe,
      ue = M(e, J),
      he = "boolean" == typeof i,
      ge = S(n(!1), 2),
      de = ge[0],
      me = ge[1],
      be = x(),
      ye = he ? i : de,
      ve = he && a ? a : me,
      xe = S(n(null), 2),
      we = xe[0],
      Oe = xe[1],
      je = null != G ? G : null == we ? void 0 : we.id,
      ke = f({
    prefix: "tooltip",
    id: je
  }),
      Ee = k(F).theme;
  r(function () {
    (b && v(b, "Icon") || O(b)) && console.warn("Using a LeafyGreenUI Icon or Glyph component as a trigger will not render a Tooltip, as these components do not render their children. To use, please wrap your trigger element in another HTML tag.");
  }, [b]);
  var Ce = o(function () {
    ("function" != typeof ne || ne()) && (fe(), ve(!1));
  }, [ve, ne, fe]),
      Pe = o(function (e, t) {
    return e === K.Hover ? {
      onMouseEnter: l(function (e) {
        n("onMouseEnter", e), ve(!0);
      }, 35),
      onMouseLeave: l(function (e) {
        n("onMouseLeave", e), Ce();
      }, 35),
      onFocus: function onFocus(e) {
        n("onFocus", e), ve(!0);
      },
      onBlur: function onBlur(e) {
        n("onBlur", e), Ce();
      }
    } : {
      onClick: function onClick(e) {
        e.target !== we && (n("onClick", e), ve(function (e) {
          return !e;
        }));
      }
    };

    function n(e, n) {
      t && t[e] && "function" == typeof t[e] && t[e](n);
    }
  }, [Ce, ve, we]);
  u(Ce, {
    enabled: ye
  });
  var Ne = o(function (e) {
    we && !we.contains(e.target) && Ce();
  }, [Ce, we]);
  h("click", Ne, {
    enabled: ye && "click" === E
  });
  var Me = C({
    refEl: se,
    popoverZIndex: ce
  }, oe ? {
    spacing: Z,
    usePortal: oe,
    portalClassName: ie,
    portalContainer: ae,
    scrollContainer: le
  } : {
    spacing: Z,
    usePortal: oe
  }),
      Ie = H && ye,
      Se = ["left", "right"].includes(D),
      Fe = t.createElement(c, N({
    key: "tooltip",
    active: Ie,
    align: D,
    justify: X,
    adjustOnMutation: !0,
    onClick: te,
    className: d(P({}, g(q || (q = I(["\n          // Try to fit all the content on one line (until it hits max-width)\n          // Overrides default behavior, which is to set width to size of the trigger.\n          // Except when justify is set to fit because the width should be the size of the trigger.\n          // Another exception is when justify is set to fit and the alignment is either left or right. In this case only the height should be the size of the trigger so we still want the width to fit the max content.\n          width: max-content;\n        "]))), X !== s.Fit || X === s.Fit && (D === V.Left || D === V.Right)))
  }, Me), function (e) {
    var n = function (e) {
      var t = e.align,
          n = e.justify,
          r = e.triggerRect;
      if (!t || !n || !r) return {
        notchContainer: "",
        notch: "",
        tooltip: ""
      };
      var o,
          i,
          a = 26,
          l = {},
          c = {},
          p = 16,
          f = 32,
          u = 0,
          h = "";

      switch (t) {
        case "top":
        case "bottom":
          switch (f = 48, o = r.width / 2 - 13, u = j(o, p, f), i = o <= p, l.left = "0px", l.right = "0px", "top" === t ? (c.top = "calc(100% - 1px)", l.top = "".concat(-9, "px")) : (c.bottom = "calc(100% - 1px)", l.bottom = "".concat(-9, "px"), l.transform = "rotate(180deg)"), n) {
            case s.Start:
              c.left = "".concat(u, "px"), i && (h = "translateX(-".concat(p - o, "px)"));
              break;

            case s.Middle:
              c.left = "0px", c.right = "0px";
              break;

            case s.Fit:
              c.left = "".concat(u, "px"), i && (h = "translateX(-".concat(p - o, "px)"));
              break;

            case s.End:
              c.right = "".concat(u, "px"), i && (h = "translateX(".concat(p - o, "px)"));
          }

          break;

        case "left":
        case "right":
          switch (f = 32, o = r.height / 2 - 13, u = j(o, p, f), i = o <= p, l.top = "0px", l.bottom = "0px", "left" === t ? (c.left = "calc(100% - 1px)", l.left = "".concat(-9, "px"), l.transform = "rotate(-90deg)") : (c.right = "calc(100% - 1px)", l.right = "".concat(-9, "px"), l.transform = "rotate(90deg)"), n) {
            case s.Start:
              c.top = "".concat(u, "px"), i && (h = "translateY(-".concat(p - o, "px)"));
              break;

            case s.Middle:
              c.top = "0px", c.bottom = "0px";
              break;

            case s.Fit:
              c.top = "".concat(u, "px"), i && (h = "translateY(-".concat(p - o, "px)"));
              break;

            case s.End:
              c.bottom = "".concat(u, "px"), i && (h = "translateY(".concat(p - o, "px)"));
          }

      }

      return {
        notchContainer: g(T || (T = I(["\n      position: absolute;\n      width: ", "px;\n      height: ", "px;\n      overflow: hidden;\n      margin: auto;\n      pointer-events: none;\n      ", ";\n    "])), a, a, g(c)),
        notch: g(A || (A = I(["\n      ", ";\n      position: absolute;\n      width: ", "px;\n      height: ", "px; // Keep it square. Rotating is simpler\n      margin: 0;\n    "])), g(l), 26, 26),
        tooltip: g(L || (L = I(["\n      min-width: ", "px;\n      transform: ", ";\n    "])), 2 * u + a, h)
      };
    }({
      align: e.align,
      justify: e.justify,
      triggerRect: e.referenceElPos
    }),
        r = n.notchContainer,
        o = n.notch,
        i = n.tooltip;

    return t.createElement("div", N({
      role: "tooltip"
    }, ue, {
      id: ke,
      className: d(Q, i, _[Ee].tooltip, P({}, ee, Se), p),
      ref: Oe
    }), t.createElement("div", {
      className: d($, w[be], _[Ee].children)
    }, m), t.createElement("div", {
      className: r
    }, t.createElement(z, {
      className: d(o),
      fill: _[Ee].notchFill
    })));
  });
  return b ? "function" == typeof b ? b(C(C({}, Pe(E)), {}, {
    className: W,
    "aria-describedby": Ie ? ke : void 0,
    children: Fe
  })) : t.cloneElement(b, C(C({}, Pe(E, b.props)), {}, {
    "aria-describedby": Ie ? ke : void 0,
    children: t.createElement(t.Fragment, null, b.props.children, Fe),
    className: d(W, b.props.className)
  })) : Fe;
}

ne.displayName = "Tooltip", ne.propTypes = {
  children: i.node,
  className: i.string,
  align: i.oneOf(Object.values(V)),
  justify: i.oneOf(Object.values(s)),
  trigger: i.oneOfType([i.node, i.func]),
  triggerEvent: i.oneOf(Object.values(K)),
  darkMode: i.bool,
  enabled: i.bool,
  open: i.bool,
  setOpen: i.func,
  id: i.string,
  shouldClose: i.func,
  usePortal: i.bool,
  portalClassName: i.string
};
export { V as Align, K as TriggerEvent, ne as default };